import 'one-ui-styles/index.less';
import './index.less';
import { init } from 'ccw-app';
import { Event } from 'one-interact';
import { Log, LogLevel } from 'one-log';
import { enableTrace } from "one-trace";
import { loader } from 'one-gadget-loader';
import { bindEvents, bindHotKeyEvents } from 'one-gadget-voice';
import { BrowserLogger } from 'one-web-logger';
import { VoiceEvent } from 'one-interact-voice';
import { HAServer, HAServerOne } from 'one-server-local-ha';
import { FinesseMakeCall } from 'one-comp-phone';
import {
    AlertNotification
} from "one-alert-notification";
import { Disposition } from 'one-model-local';
import {
    Action as KeyAction,
    Types as KeyActionTypes,
} from 'one-state-hotkeys';
import {
    format_one,
    format_three
} from 'one-util-date';

// set up the logger
const log = new Log("ccw-app", [
    new BrowserLogger(),
], LogLevel.DEBUG);

// load the gadget,
loader({
    log,
    url: './settings.json', // application settings
}, async (options: any) => {
    const {
        user,       // finesse user object
        settings,   // settings.json as json object
        resolver,   // url resolver
    } = options;

    /**
     * check for the log level config from settings and set default
     */
    let { logconfig,alertnotify,makeacall, compatible : { consolidated_api_invocation },uisettings: {panviva_config} } = settings;
    const { panviva_cvsearch} = panviva_config;
    if (logconfig?.level === "INFO") {
        log.setlevel(LogLevel.INFO);
    } else if (logconfig?.level === "WARN") {
        log.setlevel(LogLevel.WARN);
    } else if (logconfig?.level === "ERROR") {
        log.setlevel(LogLevel.ERROR);
    } else {
        log.setlevel(LogLevel.DEBUG);
    }
    // logged in agent id
    const agentId = user.getId();
    const agentLoginName = user.getData().loginName;
    const teamName=user.getData().teamName;


    // enable user specific trace
    enableTrace(agentId, {
        log,
        settings,
    });

    //enable alerting
    let  alertnotification = new AlertNotification(false,alertnotify?.url,{
    })
    if(alertnotify?.enable){
        alertnotification = new AlertNotification(true,alertnotify?.url,{
          userid:agentLoginName,
          team_name:teamName,
          customer_name:alertnotify?.customer,
          server_id:alertnotify?.servername,
          app_type:"gadget"

      })
      }

      // setup Finesse Make a call plugin
      const makecall = new FinesseMakeCall(user,log,makeacall?.prefix);

    // initialize the app
    log.debug(
        'ccw-app-gagdet',
        'initializing gadget', {
        agentId,
        settings,
    }
    );

    // wait for to app initializes
    const { store } = await init('app', {
        log,
        settings,
        resolver,
        agentId,
        teamName,
        user,
        makecall,
        agentLoginName,
        alertnotification,
        server: new HAServer(
            settings['servers'],
            (url:string,error: any) => {
                store.dispatch({
                    type: "one-state-errorhandle/set",
                    payload: {
                        url: url,
                        error: error,
                        monitor: false
                    }
                })
            }
        ),
        serverone: new HAServerOne(
            settings['servers'],
            (url:string,error: any) => {
                store.dispatch({
                    type: "one-state-errorhandle/set",
                    payload: {
                        url: url,
                        error: error,
                        monitor: false
                    }
                })
            }
        ),
    });
    // handle user change event
    user.addHandler('change', (user:any)=>{
        store.dispatch({
            type: "interact-user-set",
            payload: {
               state:user.getData().state
            }
        });
    });

    // push intial user data to state
     store.dispatch({
        type: "interact-user-set",
        payload: {
           state:user.getData().state
        }
    });

    //deliver voice events
    bindEvents({
        log,
        settings,
        alertnotification,
        user,
    }, (event: Event): void => {
        try {
            /**
             * Below variables in event data(ani, dnis, ...)
             * are directly linked to callvariable data mapped in settings.json
             */
            const { type, data: { ani, dnis, callType, callernumber, callednumber,sessionkey, reload, callertype, updatedpv, sourceid, subjectid, info, callId,employeeid, panviva_search } } = event;
            let callEndInfo: any = info;
            let incomingnumber = ani;
            let callerani;
            if (ani?.length === 12) {
                callerani = ani.slice(2)
            }
            else if (ani?.length === 10) {
                callerani = ani
            }
            else {
                callerani = ""
            }
            //Capturing ANI from Call Variable if there or else from dialog
            
            if (callernumber) {
                incomingnumber = callernumber
            }

            //Capturing DNIS from Call Variable if there or else from dialog
            let calledto = dnis;
            if (callednumber) {
                calledto = callednumber;
            }
            // if(match){
            //     pnumber = match;
            // }
            log.debug(
                'ccw-app-gagdet',
                'Call events ', {
                event
            });
            /**
             * This block indentifies the call end event 
             * and perform necessary actions (Dialog Delete)
             */
            if (type === VoiceEvent.END) {
                //push call record
                let stateobj = store.getState();
                const selectedPatient = stateobj?.subjectstore?.selected;
                let info: object = {
                    agentName: agentLoginName,
                    agentExtension: agentId,
                    patientName: `${selectedPatient?.firstname} ${selectedPatient?.lastname}`,
                    patientDOB: selectedPatient?.dob
                }
                const data = {
                    callId: callId ? callId : "0",
                    ani,
                    dnis,
                    Lang: "en-us",
                    serverIP: "192.168.1.1",
                    CallStartTime: format_one(callEndInfo?.startTime),
                    CallEndTime: format_one(callEndInfo?.stateChangeTime),
                    callDuration: format_three(callEndInfo?.startTime, callEndInfo?.stateChangeTime),
                    others: info,
                    elements: []
                }
                store.dispatch({
                    type: "push-call-record",
                    payload: data,
                });

                //Inititate Clearing the Dashbaord content
                store.dispatch({
                    type: "one-state-subject/reset",
                    payload: {
                        number: ani,
                        dnis: dnis
                    }
                });
                store.dispatch({
                    type: "one-state-choosecaller/reset",
                    payload: {
                        number: ani,
                        dnis: dnis,
                        visible:false,
                        start:false
                    }
                });
                // RESET Page to intial screen on Call END
                store.dispatch({
                    type: "one-state-tabs/set",
                    payload: "1"
                })
                //Disposition Framework
                let disp: Disposition = { value: "178" }
                disp.dial_list_uid = callId;
                disp.meta00 = agentId;
                disp.meta01 = selectedPatient?.id;
                disp.meta02 = ani;
                disp.meta03 = "";
                disp.meta04 = 'client';
                store.dispatch({
                    type: "store-disposition-code",
                    payload: disp
                })
                //Reset Dispostion Store
                store.dispatch({
                    type: "reset-disposition",
                    payload: {
                        incomingcall: false
                    }
                });
                //ADPAC-160
                sessionStorage.removeItem("selected");
                sessionStorage.removeItem("subjectid");
                sessionStorage.removeItem("sourceid");
                sessionStorage.removeItem("PatientName");
            }
            /**
             * This block indentifies the new call 
             * and perform necessary actions (Dialog ADD)
             */
            else if (type === VoiceEvent.ARRIVE) {
                log.debug(
                    'ccw-app-gagdet',
                    'Call EVENT ARRIVE  ', {
                    event
                });
                //Used for hotkeys (Consult/Trasnfer Buttons)
                store.dispatch({
                    type: 'interact-voice-set',
                    payload: event,
                });

                let callerdetailsType = "Patient";

                
                let dispatchtype = "one-state-choosecaller/set";
                /**
                 * For Refernce
                 * This logic has been moved to gadget (Verification popup screen)
                 * This code is depricated
                 */
                // 
                // if (callertype === "provider") {
                //     dispatchtype = "caller-provider";
                //     callerdetailsType = "Provider"
                //     sessionStorage.setItem("selected", "provider");
                // } else if (callertype === "patient") {
                //     dispatchtype = "caller-patient";
                //     //  callerdetailsType = "Patient";
                //     sessionStorage.setItem("selected", "patient");
                // }

                //ADPAC-160 check if page refresh and retrive selected caller.
                let hitepic = true;
                var selection = sessionStorage.getItem("selected");
                //This code is depricated
                // if (reload) {
                //     if (selection && selection === "patient") {
                //         dispatchtype = "caller-patient";
                //         //skeletonjson["subject_skeleton"] = true;
                //     }
                //     if (selection && selection === "provider") {
                //         dispatchtype = "caller-provider";
                //         callerdetailsType = "Provider"
                //     }
                // }
                // check for ANI is valid or not
                if (incomingnumber === undefined || incomingnumber === "") {
                    let errorobject: any = {
                        source: "New Call",
                        type: "error",
                        status: "error",
                        erroritems: [
                            {
                                error_code: "601",
                                error_type: "Business Exception",
                                error_detail: "Failed to Fetch Patient Details for ANI -" + incomingnumber,
                                error_description: "ANI is not proper, failed to fetch patient details"
                            }
                        ]
                    };
                    store.dispatch({
                        type: "one-state-error/add",
                        payload: errorobject,
                    });
                    // SEND to ALERT snotificiton/NOCserver for errors
                    if(alertnotification?.isEnabled()){
                        var timestamp=new Date().toJSON();
                        alertnotification.notify({
                            "error_code" : "630-31" ,
                            "error_type": "INSUFFICENT_CALL_DATA" ,
                            "error_description": "Unable to retrive data as DNIS is not available.",
                            "error_supertype":"CALL_DATA_ERROR",
                            "error_detail": "Invalid or Missing PhoneNumber",
                            "alert":"No",
                            "timestamp": timestamp ,
                            "params":event
                        });
                    }
                }
                // check for DNIS is valid or not
                if (calledto === undefined || calledto === "") {
                    let errorobject: any = {
                        source: "New Call",
                        type: "error",
                        status: "error",
                        erroritems: [
                            {
                                error_code: "602",
                                error_type: "Business Exception",
                                error_detail: "Failed to Fetch Calling Destination for  DNIS - " + calledto,
                                error_description: "DNIS is not proper, failed to fetch Calling Destination "
                            }
                        ]
                    };
                    store.dispatch({
                        type: "one-state-error/add",
                        payload: errorobject,
                    });

                    // SEND to ALERT snotificiton/NOCserver for errors
                    if(alertnotification?.isEnabled()){
                        var alertnotificationts=new Date().toJSON();
                        alertnotification.notify({
                            "error_code" : "630-31" ,
                            "error_type": "INSUFFICENT_CALL_DATA" ,
                            "error_description": "Unable to retrive data as DNIS is not available.",
                            "error_supertype":"CALL_DATA_ERROR",
                            "error_detail": "Invalid or Missing PhoneNumber",
                            "alert":"No",
                            "timestamp": alertnotificationts ,
                            "params":event
                        });
                    }

                }
                //Refine incoming number
                let address = incomingnumber?.replace(/[^a-zA-Z0-9]/g, '');
                if (address?.length > 10) {
                    var removeindex = (address.length) - 10;
                    address = address.slice(removeindex, address.length);
                }

                if (callType && (callType === "TRANSFER" || callType === "CONFERENCE") && !reload) {
                    if (selection && (selection === "patient" || selection === "provider")) {
                        hitepic = false;
                    }
                }
                // check for consult transfer
                // Depricated logic which is used for hotbuttons
                // const { updatepv } = settings;
                // if (updatepv?.usepv) {
                //     if (callType && (callType === "CONSULT") || (callType === "CONSULT_OFFERED") || (callType === "TRANSFER")) {
                //         if (updatepv?.usepv && updatepv?.usepv === "patient") {
                //             dispatchtype = "caller-patient";
                //         }
                //         if (updatedpv && updatedpv === "provider") {
                //             dispatchtype = "caller-provider";
                //         }
                //     }
                //     if (selection && ((callType === "CONSULT_OFFERED") || (callType === "TRANSFER"))) {
                //         hitepic = false;
                //     }
                //     sessionStorage.setItem("selected", updatedpv);
                //     log.debug(
                //         'ccw-app-gagdet',
                //         'consult call/trnasfer call as PV has caller type skipping the choose caller', {
                //         updatedpv, dispatchtype
                //     });
                // }
                
                log.debug(
                    'ccw-app-gagdet ',
                    'Call EVENT before for hit epic ', {
                    hitepic
                });
                if (hitepic) {
                    const { uisettings } = settings;

                    //Reset the gadget before New Call.
                    store.dispatch({
                        type: "one-state-subject/reset",
                        payload: {
                            number: "",
                            dnis: ""
                        }
                    });
                    
                    //Reset all cards to Skeleton true on Call Arrive
                    let skeletonjson = {
                        //source_skeleton: true,
                        callingDestination_skeleton: true,
                        subject_skeleton: true,
                    }
                    // This will initiate the skeleton loading component
                    store.dispatch({
                        type: "one-state-skeleton/set",
                        payload: skeletonjson
                    });
                    if(panviva_cvsearch && panviva_search?.length > 0) {
                        let userinfo = sessionStorage.getItem('panvivauserinfo');
                        store.dispatch({
                            type: "one-state-panviva/initiate",
                            payload: {
                                key:panviva_search,
                                panviva_id: userinfo ? userinfo : "",
                                type: "live_search",
                                id: "",
                                location: ""
                            }
                        })
                      }

                    //Checking whether Verification is already done.
                    let modelvisible:boolean = true;
                    var sessionsubjectid = sessionStorage.getItem("subjectid");
                    var sessionsourceid = sessionStorage.getItem("sourceid");
                    if((sessionsubjectid && sessionsubjectid?.length > 0) || (sessionsourceid && sessionsourceid?.length > 0)){
                        modelvisible = false;
                    }
                    else if((subjectid && subjectid?.length > 0) || sourceid && sourceid?.length > 0){
                        modelvisible = false;
                    }
                    if(callType && (callType === "CONSULT") || (callType === "CONSULT_OFFERED") || (callType === "TRANSFER") || (callType === "CONFERRENCE")) {
                        store.dispatch({
                            type:"one-state-selectedsubject/reinit",
                        })
                        store.dispatch({
                            type:"one-state-selectedsource/reinit",
                        })
                    }


                    //Dispatch Verification popup
                    store.dispatch({
                        type: dispatchtype,
                        payload: {
                            number: address,
                            dnis: calledto,
                            visible: modelvisible,
                            start:true,
                            callId: callId
                        }
                    });
                    //Dispatch for ServiceNow Customer Details
                    store.dispatch({
                        type: "verify-caller",
                        payload: {
                            callerdata: employeeid
                        }
                    });

                    if(consolidated_api_invocation){
                        store.dispatch({
                            type: "consolidated-api-one",
                            payload: {
                                number: address,
                                type: callerdetailsType,
                                dnis: dnis,
                                subjectid: sessionsubjectid?sessionsubjectid:subjectid,
                                sourceid: sessionsourceid?sessionsourceid:sourceid
                            }
                        });
                    } else {
                        
                        if(sessionkey) {
                            //Dispatch GetSession
                            store.dispatch({
                                type: "one-state-getsession/fetch",
                                payload: {
                                    sessionKey:sessionkey
                                }
                            });
                            }
                            else  if(callerani && callType === "PREROUTE_ACD_IN"){
                            //Dispatch Patientlookup and Entitydetails
                             store.dispatch({
                                type: "caller-patient",
                                payload: {
                                    number: callerani,
                                    dnis: calledto,
                                }
                            });
                            }
                    }


                } else {
                    log.debug(
                        'ccw-app-gagdet',
                        'events - not hitting the epic as epic dip is active ', {
                        hitepic
                    });
                }
            }
        } catch (exp) {
            log.error(
                'ccw-app-gagdet',
                'Error - Procesing Call events ', {
                exp, event
            });

            let errorobject: any = {
                source: "New Call",
                type: "error",
                status: "error",
                erroritems: [
                    {
                        error_code: "600",
                        error_type: "Business Exception",
                        error_detail: "Error Processing  Call Events",
                        error_description: exp
                    }
                ]
            };
            store.dispatch({
                type: "one-state-error/add",
                payload: errorobject,
            });

             // SEND to ALERT snotificiton/NOCserver for errors
             if(alertnotification?.isEnabled()){
                var alerterrorts=new Date().toJSON();
                alertnotification.notify({
                    "error_code" : "630-32" ,
                    "error_type": "ERROR_CALL_DATA" ,
                    "error_description": "Call event exceptions on caller events.",
                    "error_supertype":"CALL_DATA_ERROR",
                    "error_detail": "Call evens dialog errors",
                    "alert":"No",
                    "timestamp": alerterrorts ,
                    "params":event
                });
            }

        }
    });

    // deliver hotkey events
    bindHotKeyEvents({
        log,
        settings,
        user,
    }, (data: any): void => {
        log.debug(
            'ccw-app-gadget',
            'bindHotKeyEvents', {
            data
        }
        );
        const action: KeyAction<KeyActionTypes> = {
            payload: data,
            type: KeyActionTypes.SET,
        };
        store.dispatch(action);
    });

}).then((options: any) => {
    const { settings, /*services*/ } = options;
    log.debug(
        'ccw-app-gadget',
        'gadget container initiatilzed', {
        settings,
    }
    );
}).catch((exp: any) => {
    log.debug(
        'ccw-app-gadget',
        'error loading gadget',
        exp,
    );
});
